/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function ThreeDJobs(props) {
  return (
    <svg {...props} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.709 24.2219C29.9222 24.1009 30.0947 23.928 30.214 23.7243L25.6 21.1064L16 26.5533V31.7934C16.2348 31.7934 16.4696 31.7336 16.6804 31.614L29.709 24.2219Z"
        fill="#04ABB8"
      />
      <path
        d="M15.3196 31.614C15.5304 31.7336 15.7652 31.7934 16 31.7934V26.5533L6.40003 21.1064L1.78601 23.7243C1.90532 23.928 2.07781 24.1009 2.29104 24.2219L15.3196 31.614Z"
        fill="#19BCC9"
      />
      <path
        d="M1.78596 23.7244C1.66617 23.5199 1.59998 23.2845 1.59998 23.0397V8.96058C1.59998 8.71576 1.66617 8.48035 1.78596 8.27588L6.39998 10.8938V21.1065L1.78596 23.7244Z"
        fill="url(#paint0_linear_13974_172474)"
      />
      <path
        d="M6.40003 10.8935L19.9665 3.19622C20.3351 2.98712 20.335 2.45949 19.9665 2.25039L16.6797 0.385522C16.2582 0.146739 15.741 0.146883 15.3196 0.385957L2.29103 7.77805C2.07781 7.89903 1.90532 8.07199 1.78601 8.27564L6.40003 10.8935Z"
        fill="#19BCC9"
      />
      <path
        d="M30.214 8.27588L25.6 10.8938V21.1065L30.214 23.7244C30.3338 23.5199 30.4 23.2845 30.4 23.0397V8.96058C30.4 8.71576 30.3338 8.48035 30.214 8.27588Z"
        fill="url(#paint1_linear_13974_172474)"
      />
      <path
        d="M30.214 8.27561C30.0949 8.07239 29.9229 7.89974 29.7103 7.7788L26.2796 5.8323L26.2759 5.8302C25.8551 5.59352 25.3397 5.59436 24.9196 5.83273L12.0335 13.144C11.6649 13.3531 11.6649 13.8807 12.0335 14.0898L15.3327 15.9617C15.7481 16.1914 16.2539 16.1911 16.669 15.9607L30.214 8.27561Z"
        fill="#19BCC9"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13974_172474"
          x1="9.14283"
          y1="8.17016"
          x2="-1.04045"
          y2="23.8961"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02939F" />
          <stop offset="0.399305" stopColor="#19BCC9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13974_172474"
          x1="33.1428"
          y1="8.17016"
          x2="22.9595"
          y2="23.8961"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02939F" />
          <stop offset="0.399305" stopColor="#19BCC9" />
        </linearGradient>
      </defs>
    </svg>
  )
}

ThreeDJobs.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default ThreeDJobs
